// Toast hook wrapper for Chakra UI

import { useToast as useChakraToast, UseToastOptions } from '@chakra-ui/react';

/**
 * Wrapper hook for consistent toast notifications
 */
export function useToast() {
  const chakraToast = useChakraToast();

  const toast = {
    success: (message: string, options?: UseToastOptions) => {
      chakraToast({
        title: message,
        status: 'success',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
        ...options,
      });
    },
    error: (message: string, options?: UseToastOptions) => {
      chakraToast({
        title: message,
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
        ...options,
      });
    },
    info: (message: string, options?: UseToastOptions) => {
      chakraToast({
        title: message,
        status: 'info',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
        ...options,
      });
    },
    warning: (message: string, options?: UseToastOptions) => {
      chakraToast({
        title: message,
        status: 'warning',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
        ...options,
      });
    },
  };

  return toast;
}
